import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { GetPetDetailsFromPolicyNumber } from '../helpers/petHelpers'; // Adjust the path as necessary
import { revertLegacyPolicyNumberFormat } from '../helpers/paymentHelper';

export const useActivePet = ({ petDetails }) => {
  const [searchParams] = useSearchParams();
  const activePolicyId = searchParams.get('policyId');
  const formattedPolicyId = activePolicyId ? revertLegacyPolicyNumberFormat(activePolicyId) : '';

  const activePet = useMemo(
    () =>
      activePolicyId && formattedPolicyId
        ? GetPetDetailsFromPolicyNumber({ petDetails, policyNumber: formattedPolicyId })
        : null,
    [activePolicyId, formattedPolicyId, petDetails]
  );

  return { activePet, activePolicyId };
};
